import React, { useState, useEffect } from 'react';
import { styles } from '../theme';
import { API_URL, fetchWithAuth } from '../api';
import { formatPHDatetime } from '../utils/dateUtils';

const formatDateTime = (v) => v ? formatPHDatetime(v) : '-';

const PosPinSettings = ({ token }) => {
  const [status, setStatus] = useState(null);
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [message, setMessage] = useState(null);

  const fetchStatus = async () => {
    try {
      const res = await fetchWithAuth(`${API_URL}/users/me/pos-pin`, { headers: { Authorization: `Bearer ${token}` } });
      setStatus(await res.json());
    } catch (err) {
      console.error('Error fetching PIN status:', err);
    }
  };

  useEffect(() => { fetchStatus(); }, []);

  const handleSubmit = async () => {
    setMessage(null);
    try {
      const res = await fetchWithAuth(`${API_URL}/users/me/pos-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ pin, confirm_pin: confirmPin })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ type: 'success', text: 'POS PIN updated successfully.' });
        setPin('');
        setConfirmPin('');
        fetchStatus();
      } else {
        setMessage({ type: 'error', text: data.error || 'Something went wrong.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Network error, please try again.' });
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '0 auto' }}>
      <div style={styles.header}>
        <h1 style={styles.title}>POS PIN</h1>
      </div>

      <div style={styles.card}>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 16px 0' }}>
          This 4-digit PIN identifies you as the operator when using a shared POS terminal
          (opening/closing shifts, ringing up sales) — it does not replace your regular login.
        </p>

        {status && (
          <div style={{
            fontSize: '13px', padding: '10px 12px', borderRadius: '6px', marginBottom: '20px',
            backgroundColor: status.locked ? '#fef2f2' : '#f0fdf4',
            color: status.locked ? '#b91c1c' : '#166534'
          }}>
            {status.locked
              ? 'Your PIN is currently locked after too many failed attempts. Setting a new one below will unlock it.'
              : status.has_pin
                ? `PIN set on ${formatDateTime(status.pos_pin_set_at)}. Setting a new one below replaces it.`
                : 'No PIN set yet.'}
          </div>
        )}

        {message && (
          <div style={{
            fontSize: '13px', padding: '10px 12px', borderRadius: '6px', marginBottom: '16px',
            backgroundColor: message.type === 'success' ? '#f0fdf4' : '#fef2f2',
            color: message.type === 'success' ? '#166534' : '#b91c1c'
          }}>
            {message.text}
          </div>
        )}

        <div style={styles.formGroup}>
          <label style={styles.label}>New 4-Digit PIN</label>
          <input
            type="password"
            inputMode="numeric"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            style={styles.input}
            placeholder="••••"
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Confirm PIN</label>
          <input
            type="password"
            inputMode="numeric"
            maxLength={4}
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            style={styles.input}
            placeholder="••••"
          />
        </div>

        <button onClick={handleSubmit} style={{ ...styles.button, width: '100%', justifyContent: 'center' }}>
          {status?.has_pin ? 'Update PIN' : 'Set PIN'}
        </button>
      </div>
    </div>
  );
};

export default PosPinSettings;
